// extracted by mini-css-extract-plugin
export default {"bodyWrapper":"VerifyAccount_bodyWrapper__HiOzH","loadingText":"VerifyAccount_loadingText__Ann5W","errorText":"VerifyAccount_errorText__MdrFv"};